import gql from 'graphql-tag';

const SEARCH_CONTRACTS_QUERY = gql`
  query ($fields: [String]!, $searchValue: String!) {  
    searchContracts(fields:$fields, value: $searchValue){
      contractId
      contractNumber 
      annualPremiumAllIn    
      customer {            
        firstName
        lastName  
      }    
      enterprise {            
        name
      }    
      insuranceBroker {      
        name
        producerNumber
      }
      simulation {
        simulationNumber
        dateSimulation
        simulationType
      }
    }
  }
`;

export default SEARCH_CONTRACTS_QUERY;
